export default __webpack_public_path__ + "images/FV.3738711.png";